<template>
  <pre>{{ JSON.stringify(revision) }}</pre>
</template>

<script>

export default {
  props: {
    revision: {
      type: Object,
      required: true
    }
  }
}
</script>
